__turbopack_context__.v({
  "footerLink": "FooterLink-module-scss-module___E7zGa__footerLink",
});
